/* eslint-disable react/no-unused-state */

import classnames from "classnames";
import isEqual from "lodash.isequal";
import React from "react";

import lazyLoadMap from "../../shared/helpers/map_loader";
import { gaEvent } from "../../shared/helpers/gtm_tracking";

import scrollToElement from "../../utils/SmoothScroller";

import AsyncResultsMap from "./AsyncResultsMap.jsx";
import ResultsList from "./ResultsList.jsx";
import NoResultsBumper from "./NoResultsBumper.jsx";

const BASE_STATE = {
  highlightedOfferId: null,
  loadedResults: null,
  page: 1
};
const HIGHLIGHT_OFFSET = 1 / 10;
const RESULTS_PER_PAGE = 18;
const SCROLL_TIME = 500;

const findCheapestPackage = (results = []) => {
  if (!results.length) {
    return null;
  }

  const { name, package: pkg } = results.reduce((prev, curr) => {
    return prev.package.price < curr.package.price ? prev : curr;
  });

  return { name, price: pkg.price };
};

class SearchResults extends React.Component {
  constructor() {
    super();

    this.state = {
      ...BASE_STATE,
      isMapLoaded: !!(window.google && window.google.maps),
      isMapView: false
    };
  }

  componentDidMount() {
    const self = this;

    self.setState(self.stateForPage(1));
  }

  componentDidUpdate(prevProps) {
    const self = this;

    if (!isEqual(prevProps.results, self.props.results)) {
      self.setState(self.stateForPage(self.state.page));
    }
  }

  stateForPage = page => {
    const start = (page - 1) * RESULTS_PER_PAGE;
    const end = page * RESULTS_PER_PAGE;
    const isMapLoaded = !!(window.google && window.google.maps);
    const loadedResults = this.props.results.slice(start, end);

    return {
      ...BASE_STATE,
      isMapLoaded,
      loadedResults,
      page
    };
  };

  handleTabClick = label => e => {
    e.preventDefault();

    const self = this;
    const isMapTabClicked = label === "Map";
    const newState = { ...self.state, isMapView: isMapTabClicked, highlightedOfferId: null };

    if (isMapTabClicked && !self.state.isMapLoaded) {
      lazyLoadMap(() => { self.setState({ ...newState, isMapLoaded: true }); });
    } else {
      self.setState(newState);
    }

    gaEvent("Search Page", "Search Tab", label);
  };

  handleMarkerClick = id => {
    return () => {
      this.scrollToOffer(id);
      this.highlightOffer(id);
      gaEvent("Search Page", "Map marker", id);
    };
  };

  handlePageClick = data => {
    scrollToElement({
      selector: "#js-search-list",
      duration: SCROLL_TIME,
      callback: () => {
        const self = this;

        self.setState(self.stateForPage(data.selected + 1));
      }
    });
  };

  scrollToOffer(id) {
    const self = this;
    const index = self.props.results.findIndex(result =>
      id === `${result.slug}-${result.package._id}`
    ) + 1;
    const page = index ? Math.ceil(index / RESULTS_PER_PAGE) : 1;

    if (page === self.state.page) {
      self.scrollTo(id);
    } else {
      self.setState(self.stateForPage(page), () => self.scrollTo(id));
    }
  }

  scrollTo = id => {
    const offer = document.getElementById(id);

    if (offer) {
      const yScroll = Math.floor((window.pageYOffset + offer.getBoundingClientRect().top)
        - ((window.innerHeight * HIGHLIGHT_OFFSET) + 1));

      window.scroll(0, yScroll);
    }
  };

  highlightOffer = highlightedOfferId => {
    this.setState({ highlightedOfferId });
  };

  renderBumper() {
    return (
      <div className="wrapper">
        <div className="layout">
          <div className="layout__item" aria-labelledby="aria-callout-box-title">
            <NoResultsBumper {...this.props} />
          </div>
        </div>
      </div>
    );
  }

  renderListControls() {
    const self = this;
    const { isMapView } = self.state;

    return (
      <div className="wrapper">
        <ul className="nav nav-tabs nav-tabs--custom nav-tabs--alt search-tabs hide-handheld">
          <li className={classnames(!isMapView && "active")}>
            <a href="#" onClick={self.handleTabClick("List")}>List</a>
          </li>
          {/* <li className={classnames(isMapView && "active")}>
            <a href="#" onClick={self.handleTabClick("Map")}>Map</a>
          </li> */}
        </ul>
      </div>
    );
  }

  renderMap() {
    const self = this;
    const { state } = self;
    const { isMapView } = state;

    return state.isMapLoaded && (
      <div
        className={classnames(
          "search-map hide-handheld layout__item u-1/2 u-3/5-desk",
          !isMapView && "hide"
        )}
      >
        <AsyncResultsMap
          handleMarkerClick={self.handleMarkerClick}
          highlightedOfferId={state.highlightedOfferId}
          results={self.props.results}
          visible={isMapView}
        />
      </div>
    );
  }

  renderResults() {
    const self = this;
    const { props, state } = self;

    return (
      <div className={classnames("wrapper", state.isMapView && "wrapper--wide")}>
        <div className="layout">
          <ResultsList
            arrivalDate={props.params.date}
            highlightOffer={self.highlightOffer}
            pageCount={Math.ceil(props.results.length / RESULTS_PER_PAGE)}
            handlePageClick={self.handlePageClick}
            fallbackNumber={props.fallbackNumber}
            fallbackNumberHref={props.fallbackNumberHref}
            {...state}
          />

          {self.renderMap()}
        </div>
      </div>
    );
  }

  render() {
    const self = this;
    const { resultsCount, results = [] } = self.props;
    const { loadedResults } = self.state;

    if (loadedResults === null || resultsCount === null) {
      return null;
    }

    return (results.length)
      ? (
        <React.Fragment>
          {self.renderListControls()}

          {self.renderResults()}
        </React.Fragment>
      )
      : self.renderBumper();
  }
}

export default SearchResults;
export { findCheapestPackage };



// WEBPACK FOOTER //
// ./components/search/SearchResults.jsx